var $ = window.jQuery;
$(document).ready(function() {

	$('.button--next').on('click', function() {
		var $this = $('.testimonial--current');

		var $next = $this.next('blockquote');
		if ($next.length === 0) {
			$next = $this.siblings('blockquote:first');
		}

		$this.removeClass('testimonial--current');
		$next.addClass('testimonial--current');
	});

	$('.button--prev').on('click', function() {
		var $this = $('.testimonial--current');

		var $prev = $this.prev('blockquote');
		if ($prev.length === 0) {
			$prev = $this.siblings('blockquote:last');
		}

		$this.removeClass('testimonial--current');
		$prev.addClass('testimonial--current');
	});
});
